import $ from 'jquery'
import { fadeIn, fadeOut } from '../util'
import MapPopup from './MapPopup'
import SmoothScroll from 'smooth-scroll'

const MapTable = (() => {
  const manager = {
    container: document.querySelector('.js-map-table-container'),
    tableTitle: document.querySelector('.js-map-table-title'),
    tableHeader: document.querySelector('.js-map-table-header'),
    tableBody: document.querySelector('.js-map-table-body'),
    jsons: document.querySelectorAll('.js-map-json'),
    form: document.querySelector('.js-map-table-form'),
    search: document.querySelector('.js-map-table-search'),
    searchClear: document.querySelector('.js-map-table-search-remove'),
    selectContainer: document.querySelector('.js-map-table-select-container'),
    modalCtaEls: document.querySelectorAll('.js-map-table-cta'),
    modalCtas: [],

    instances: [],

    activeFilter: '',
    activeInstance: null,
    isTableVisible: false,

    pagination: {
      current: 0,
      total: 0,
      isVisible: false,
      container: document.querySelector('.js-map-table-pagination'),
      firstButton: document.querySelector('.js-map-table-first'),
      prevButton: document.querySelector('.js-map-table-prev'),
      pagesContainer: document.querySelector('.js-map-table-pages'),
      nextButton: document.querySelector('.js-map-table-next'),
      lastButton: document.querySelector('.js-map-table-last'),
      pages: [],
      perPage: window.matchMedia('(min-width:1025px)').matches ? 50 : 10,
      haveButtonsListener: false
    },

    tableVoices: document.querySelector('.js-map-config') ? JSON.parse(document.querySelector('.js-map-config').getAttribute('data-config')) : null,

    filterResults: function (e) {
      e.preventDefault()
      const searchValue = this.search.value
      const selectedCountry = this.activeInstance.selectedCountry
      const selectedRegion = this.activeInstance.selectedRegion

      if (searchValue != '' || selectedCountry != '' || selectedRegion != '') {
        fadeOut(this.pagination.container, 0)
        this.activeInstance.rows.map((row, i) => {
          let searchCondition = false
          if (searchValue) {
            searchCondition = row.searchValue.toLowerCase().indexOf(searchValue.toLowerCase()) > -1 ? true : false
          } else {
            searchCondition = true
          }

          let countryValid = false
          if (selectedCountry) {
            countryValid = row.country == selectedCountry
          } else {
            countryValid = true
          }

          let regionValid = false
          if (selectedRegion) {
            regionValid = row.region == selectedRegion
          } else {
            regionValid = true
          }

          if (searchCondition && countryValid && regionValid) {
            fadeIn(row.el, 400, 'table-row')
          } else {
            fadeOut(row.el, 0)
          }
        })
      } else {
        if (this.activeInstance) this.renderPagination(this.activeInstance)
      }
    },

    renderTable: function (_) {
      const tableContents = this.tableVoices[_.type]['languages'][window.language]
      const tableSearchString = this.tableVoices[_.type]['searchString']

      this.tableTitle.innerHTML = tableContents.title

      let header = '<tr>'
      for (let key in tableContents.table) {
        header += `<th>${tableContents.table[key]}</th>`
      }
      header += '</tr>'

      this.tableHeader.innerHTML = header

      let body = ''
      _.rows.forEach(r => {
        let searchValue = ''
        for (let i = 0; i < tableSearchString.length; i++) {
          const string = r.json[tableSearchString[i]] ? r.json[tableSearchString[i]].toLowerCase() : null
          if (string) searchValue += i === tableSearchString.length - 1 ? string : `${string} `
        }
        r.searchValue = searchValue

        let row = `<tr class="js-map-table-row">`
        for (let key in tableContents.table) {
          const text = r.json[key] ? r.json[key] : ''
          if (key == 'pathways') {
            row += '<td style="min-width: 320px;">'
          } else {
            row += '<td>'
          }
          row += text.replace(/\r?\n/g, '<br />')
          if (key == 'contacts') {
            row += '<br>'
            row += `<span class="c-button c-button--main c-map-table__button js-map-popup-open" data-request="${_.type} ${r.json.uuid}">INFO</span>`
          }
          row += '</td>'
        }
        
        row += '</tr>'
        body += row
      })

      this.tableBody.innerHTML = body
      const rows = document.querySelectorAll('.js-map-table-row')

      rows.forEach((el, i) => {
        _.rows[i].el = el
      })

      MapPopup.init()
    },

    renderSelect: function (_) {
      // render country select
      const countryPlaceholder = this.tableVoices[_.type]['languages'][window.language]['selectPlaceholder']['country']
      let countryHtml = `<select class="js-map-table-country" placeholder="${countryPlaceholder}">`
      const countries = Object.keys(_.selects)

      for (let i = 0; i < countries.length; i++) {
        const value = countries[i]
        countryHtml += `<option value="${value ? value : ''}">${value ? value : ''}</option>`
      }
      countryHtml += '</select>'

      // render region select
      const regionPlaceholder = this.tableVoices[_.type]['languages'][window.language]['selectPlaceholder']['region']
      let regionHtml = `<select class="js-map-table-region" placeholder="${regionPlaceholder}">`

      // loop every country and render every region (they'll be showed/hidden on country select)
      for (let key in countries) {
        for (let i = 0; i < _.selects[countries[key]].length; i++) {
          const value = _.selects[countries[key]][i]
          regionHtml += `<option value="${value ? value : ''}">${value ? value : ''}</option>`
        }
      }
      regionHtml += '</select>'

      // add to dom, get dom elements, init instances
      this.selectContainer.innerHTML = countryHtml + regionHtml
      _.countrySelect = document.querySelector('.js-map-table-country')
      _.regionSelect = document.querySelector('.js-map-table-region')
      _.regionOptions = _.regionSelect.querySelectorAll('option')
      // country
      _.countrySelectize = $(_.countrySelect).selectize({
        onChange: value => {
          if (value) {
            _.selectedCountry = value
            _.selectedRegion = ''
            _.regionSelectize[0].selectize.clear()
            _.regionSelectize[0].selectize.clearOptions()
            _.selects[value].forEach(v => {
              _.regionSelectize[0].selectize.addOption({
                value: v,
                text: v
              })
            })
          } else {
            _.selectedCountry = ''
          }
        }
      })
      _.countrySelectize[0].selectize.clear()
      // region
      _.regionSelectize = $(_.regionSelect).selectize({
        onChange: value => {
          if (value) {
            _.selectedRegion = value
          } else {
            _.selectedRegion = ''
          }
        }
      })
      _.regionSelectize[0].selectize.clear()

      // manage hidden button
      this.searchClear.addEventListener('click', () => {
        _.countrySelectize[0].selectize.clear()
        _.regionSelectize[0].selectize.clear()
        if (this.activeInstance) this.renderPagination(this.activeInstance)
      })
    },

    renderPagination: function (_) {
      if (_.rows.length > this.pagination.perPage) {
        // reset initial values
        this.pagination.current = 0
        this.pagination.isVisible = true
        this.pagination.total = Math.ceil(_.rows.length / this.pagination.perPage)
        this.generatePagination(_)
        this.updatePagination()

        // prev/next, first/last listeners
        if (!this.pagination.haveButtonsListener) {
          if (this.pagination.firstButton) {
            this.pagination.firstButton.addEventListener('click', (e) => {
              e.preventDefault()
              this.onPaginationClick(0)
            })
          }
          if (this.pagination.prevButton) {
            this.pagination.prevButton.addEventListener('click', (e) => {
              e.preventDefault()
              this.onPaginationClick(this.pagination.current - 1)
            })
          }
          if (this.pagination.nextButton) {
            this.pagination.nextButton.addEventListener('click', (e) => {
              e.preventDefault()
              this.onPaginationClick(this.pagination.current + 1)
            })
          }
          if (this.pagination.lastButton) {
            this.pagination.lastButton.addEventListener('click', (e) => {
              e.preventDefault()
              this.onPaginationClick(this.pagination.total - 1)
            })
          }
          this.pagination.haveButtonsListener = true
        }
        fadeIn(this.pagination.container, 0, 'flex')
      } else {
        this.pagination.isVisible = false
        fadeOut(this.pagination.container, 0)
        this.resetPagination()
      }
    },

    generatePagination: function (_) {
      let html = ''
      // let base = (this.pagination.current > 0 ? this.pagination.current : 0)
      // for (let i = base; i <= base + 3; i++) {
      //   html += `<span class="page js-map-table-page${i === this.pagination.current ? ' current': ''}">${i+1}</span>`
      // }
      this.pagination.pagesContainer.innerHTML = html
      this.pagination.pages = document.querySelectorAll('.js-map-table-page')
      for (let i = 0; i < this.pagination.pages.length; i++) {
        this.pagination.pages[i].addEventListener('click', (e) => {
          e.preventDefault()
          this.onPaginationClick(i)
        })
      }
    },

    onPaginationClick: function (i) {
      const scroll = new SmoothScroll()
      scroll.animateScroll(document.getElementById('js-table-wrapper'), null, { offset: 200})

      setTimeout(() => {
        this.pagination.current = i
        this.updatePagination()
      }, 500)
    },

    updatePagination: function () {
      if (this.pagination.current === 0) {
        fadeOut(this.pagination.firstButton, 0)
        fadeOut(this.pagination.prevButton, 0)
      } else {
        fadeIn(this.pagination.firstButton, 0)
        fadeIn(this.pagination.prevButton, 0)
      }
      if (this.pagination.current === this.pagination.total - 1) {
        fadeOut(this.pagination.nextButton, 0)
        fadeOut(this.pagination.lastButton, 0)
      } else {
        fadeIn(this.pagination.nextButton, 0)
        fadeIn(this.pagination.lastButton, 0)
      }
      this.pagination.pages.forEach((el, i) => {
        if (i === this.pagination.current) {
          el.classList.add('current')
        } else {
          el.classList.remove('current')
        }
        if (i >= this.pagination.current - 2 || i <= this.pagination.current + 2) {
          fadeIn(el, 0)
        } else {
          fadeOut(el, 0)
        }
      })

      // show/hide rows based on current
      const _ = this.activeInstance
      const fromIndex = (this.pagination.current * this.pagination.perPage)
      const toIndex = (this.pagination.current * this.pagination.perPage) + this.pagination.perPage
      Array.prototype.map.call(_.rows, (row, i) => {
        if (i >= fromIndex && i < toIndex) {
          fadeIn(row.el, 0, 'table-row')
        } else {
          fadeOut(row.el, 0)
        }
      })
    },

    resetPagination: function () {
      Array.prototype.map.call(this.activeInstance.rows, row => {
        fadeIn(row.el, 0, 'table-row')
      })
    },

    updateTable: function (filter) {
      const instance = this.instances.find(i => i.type === filter)

			if (instance) {
        if (!this.isTableVisible) {
          this.isTableVisible = true
          if (this.activeFilter !== filter) {
            this.activeFilter = filter
            this.activeInstance = instance
            this.renderSelect(instance)
            this.renderTable(instance)
            this.renderPagination(instance)
          }
          fadeIn(this.container, 600)
        } else {
          if (this.activeFilter !== filter) {
            this.activeFilter = filter
            this.activeInstance = instance
            this.renderSelect(instance)
            this.renderTable(instance)
            this.renderPagination(instance)
          }
        }

        this.modalCtas.forEach(_ => {
          if (_.id === filter) {
            _.el.classList.add('is-visible')
          } else {
            _.el.classList.remove('is-visible')
          }
        })
      } else {
        this.isTableVisible = false
        this.activeFilter = ''
        this.activeInstance = null
        fadeOut(this.container, 600)
      }
    },

    init: function (filter) {
      if (this.container) {
        this.filterResults = this.filterResults.bind(this)

        this.jsons.forEach(el => {
          const type = el.getAttribute('data-type')
          const jsonAttr = el.getAttribute('data-json')
          let json = jsonAttr ? JSON.parse(jsonAttr) : []

          const selects = {}

          const rows = []
          json.forEach(item => {
            const country = item['contacts_country']
            const region = item['contacts_region']
            
            if (selects[country]) {
            // if country exists, check region values and eventually add region value
              if (selects[country].findIndex(val => val === region) === -1) {
                selects[country].push(region)
              }

              selects[country] = selects[country].sort()
            } else {
            // if doesn't exist create array and push region value
              selects[country] = [region]
            }
            
            rows.push({
              json: item,
              el: null,
              searchValue: '',
              country,
              region
            })
          })

          this.instances.push({
            type,
            rows,
            selects,
            select: null,
            selectedCountry: '',
            selectedRegion: ''
          })
        })

        if (this.searchClear) {
          this.searchClear.addEventListener('click', () => {
            this.search.value = ''
          })
        }
        if (this.form) {
          this.form.addEventListener('submit', this.filterResults)
        }

        if (this.modalCtaEls.length) {
          this.modalCtaEls.forEach(el => {
            this.modalCtas.push({
              el,
              id: el.getAttribute('data-table')
            })
          })
        }

        this.updateTable(filter)
      }
    },

    resize: function () {
      // Cause problems on mobile when keyboard change
      // this.pagination.perPage = window.matchMedia('(min-width:1025px)').matches ? 50 : 10
      // if (this.activeInstance) this.renderPagination(this.activeInstance)
    }
  }

  const init = filter => {
    if (!document.querySelector('.js-map-table-container')) return

    manager.init(filter)
  }

  const resize = () => {
    manager.resize()
  }

  const updateTable = filter => {
    manager.updateTable(filter)
  }

  return {
    init,
    resize,
    updateTable
  }
})()

export default MapTable


// WEBPACK FOOTER //
// app/javascript/scripts/components/MapTable.js